export default "__VITE_ASSET__Bs5UaT$m__"